// loginState values provided by X1
export const LOGIN_STATE = {
  loggedIn: 'LOGGED_IN',
  loggedOut: 'LOGGED_OUT',
  softLoggedIn: 'SOFT_LOGGED_IN',
};
